import { render, staticRenderFns } from "./ProcessFlowDialog.vue?vue&type=template&id=895711c0&scoped=true"
import script from "./ProcessFlowDialog.vue?vue&type=script&lang=js"
export * from "./ProcessFlowDialog.vue?vue&type=script&lang=js"
import style0 from "./ProcessFlowDialog.vue?vue&type=style&index=0&id=895711c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895711c0",
  null
  
)

export default component.exports